<template>
  <section>
    <header class="page-header -sub-page">
      <section class="page-header__hgroup">
        <h1 v-appear:right="{ delay: [$scroll, 650] }" class="page-header__title">{{ conference.name }}</h1>

        <h2 v-appear:right="{ delay: [$scroll, 700, 50] }" class="layout-section__subtitle -accent">
          {{ title }}
        </h2>
      </section>
    </header>

    <section class="layout-section">
      <div v-for="(group, groupIndex) in board" :key="groupIndex" class="layout-section__content">
        <section
          v-appear:right="{ delay: !groupIndex ? [$scroll, 750, 100] : 0 }"
          class="layout-section__hgroup -flex -spacing"
        >
          <h2 class="layout-section__heading -bigger">{{ group.title }}</h2>
        </section>

        <article class="layout-grid -smaller">
          <section
            v-for="({ name, info, image }, memberIndex) in group.members"
            :key="name"
            v-appear="{ threshold: 0, offset: 0, delay: getDelay(groupIndex, memberIndex) }"
            class="layout-grid__item"
          >
            <figure
              class="layout-grid__figure -profile"
              :style="{ '--image': `url('${image}')` }"
              @click="setModalMember(groupIndex, memberIndex)"
            />

            <div class="layout-grid__content">
              <h6 class="layout-grid__title -spacing">{{ name }}</h6>
              <p>{{ info }}</p>
            </div>
          </section>
        </article>
      </div>
    </section>

    <article id="about" class="layout-section -split">
      <figure v-appear:right class="layout-section__figure" :style="{ '--image': `url('${conference.thumbnail}')` }" />

      <section class="layout-section__content">
        <div class="layout-section__hgroup">
          <h2 v-appear:right="{ delay: 100 }" class="layout-section__title -no-bottom">{{ conference.name }}</h2>
        </div>

        <p v-appear:right="{ delay: 200 }">{{ conference.description }}</p>

        <LocaleLink
          v-appear:right="{ delay: 300 }"
          :to="{ name: 'conference', params: { slug } }"
          class="button layout-section__cta"
        >
          {{ $t('common.cta.learnMore') }}
        </LocaleLink>
      </section>
    </article>

    <OverlayModal :is-open="!!modalMember" v-bind="modalMember" @close="modalMember = null" />
  </section>
</template>

<script>
export default {
  name: 'ConferenceBoard',
  props: {
    slug: { type: String, required: true },
    isAdvisory: { type: Boolean, default: false }
  },
  metaInfo() {
    return {
      title: `${this.title} | ${this.conference.name}`
    }
  },
  data() {
    return {
      modalMember: null
    }
  },
  computed: {
    conference() {
      return this.$i18n.messages[this.$i18n.locale].conferences[this.slug]
    },
    board() {
      return this.isAdvisory ? this.conference.advisory : this.conference.governors
    },
    title() {
      return this.isAdvisory ? this.$t('common.advisoryBoard') : this.$t('common.boardOfGovernors')
    },
    hasPage() {
      return this.isAdvisory ? this.conference.hasAdvisory === 'true' : this.conference.hasGovernors === 'true'
    }
  },
  methods: {
    getDelay(groupIndex, memberIndex) {
      const isFirstRow = !groupIndex && memberIndex < 4
      const delay = (memberIndex * 50) % 200
      return isFirstRow ? [this.$scroll, 800 + delay, delay] : delay
    },
    setModalMember(groupIndex, memberIndex) {
      const { name, info, description } = this.board[groupIndex].members[memberIndex]
      this.modalMember = { title: name, subtitle: info, content: description }
    }
  }
}
</script>
